:host {
  display: block;
  text-align: center;
  margin-top: 1rem;
}

.response-button {
  padding: 0.75rem 1.5rem;
  background-color: var(--theme-button-color, #007bff);
  color: var(--theme-primary-color, #fff);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  width: fit-content;
}

.response-button:disabled {
  background-color: var(--theme-button-color-disabled, #ccc);
  cursor: not-allowed;
}

.response-button:hover:not(:disabled) {
  background-color: var(--theme-button-color-hover, #0056b3);
}
